
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perfil/configuracion/favoritos",
      function () {
        return require("private-next-pages/perfil/configuracion/favoritos/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/perfil/configuracion/favoritos"])
      });
    }
  